import { router, useLocalSearchParams } from 'expo-router';
import type { Href } from 'expo-router';
import { useCallback } from 'react';

import { getFirstSearchParam } from '@fhs/utils';

/**
 * Closing the locator must leave the guest's currently selected store untouched, so this only
 * unwinds navigation. Mirrors the legacy screen header: honour an explicit `closeTo`, then the
 * back stack, then fall back to the homepage.
 */
export function useCloseStoreLocator() {
  const { closeTo } = useLocalSearchParams<{ closeTo?: string | string[] }>();
  const closeToHref = getFirstSearchParam(closeTo);

  return useCallback(() => {
    if (closeToHref) {
      router.dismissTo(closeToHref as Href);
      return;
    }

    if (router.canGoBack()) {
      router.back();
      return;
    }

    router.replace('/');
  }, [closeToHref]);
}
